// extracted by mini-css-extract-plugin
module.exports = {"absoluteObject":"ToolsContainer_absoluteObject__iT4F6"};